import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CommandPostBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.COMMAND_POST;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default CommandPostBuildingTileEntity;
